// Un solo lugar describe el admin: de aquí salen el menú lateral, el encabezado
// de cada pantalla y las etiquetas de los campos. Si cambia algo en la página,
// se actualiza este archivo y el panel queda al día.
//
// `key` de las secciones de página = documento en Firestore (website/<key>).

export interface ISection {
	key: string;
	label: string;
	hint: string;
}

// En el mismo orden en que aparecen al bajar por la página.
export const PAGE_SECTIONS: ISection[] = [
	{
		key: "banner",
		label: "Portada",
		hint: "Lo primero que se ve al entrar: foto de fondo, silueta, logo del encabezado y el nombre grande.",
	},
	{
		key: "about",
		label: "Sobre mí",
		hint: "La biografía y el carrusel de fotos, debajo de la banda de accesos rápidos.",
	},
	{
		key: "testimonials",
		label: "Gestión en video",
		hint: "Los videos de control político y la foto de fondo de esa franja.",
	},
	{
		key: "reports",
		label: "Denuncias · tuits",
		hint: "El banner amarillo DENUNCIAS y los tuits que se muestran debajo.",
	},
	{
		key: "reportForm",
		label: "Denuncia aquí",
		hint: "Las imágenes del formulario donde la gente envía sus denuncias.",
	},
	{
		key: "contact",
		label: "La Milagrosa",
		hint: "Los episodios del pódcast y la foto de fondo de la sección.",
	},
	{
		key: "footer",
		label: "Pie de página",
		hint: "Logo y foto de fondo del cierre de la página.",
	},
];

export const NEWS_SECTIONS: ISection[] = [
	{
		key: "blog-new",
		label: "Escribir noticia",
		hint: "Publica una entrada nueva. Sale en la sección Noticias, entre Sobre mí y Gestión.",
	},
	{
		key: "blog-list",
		label: "Noticias publicadas",
		hint: "Las entradas que ya están en línea.",
	},
];

export const INBOX_SECTIONS: ISection[] = [
	{
		key: "inbox-reports",
		label: "Denuncias recibidas",
		hint: "Lo que la gente envió por el formulario Denuncia aquí.",
	},
	{
		key: "inbox-contacts",
		label: "Contactos recibidos",
		hint: "Datos que dejó la gente cuando estaba el formulario de voluntarios. Solo lectura del histórico.",
	},
];

export const ALL_SECTIONS = [
	...PAGE_SECTIONS,
	...NEWS_SECTIONS,
	...INBOX_SECTIONS,
];

// Los ids de Firestore (title1, name2, banner…) no le dicen nada a nadie.
const FIELD_LABELS: Record<string, string> = {
	// Portada
	"banner.banner": "Foto de fondo",
	"banner.profile": "Silueta de Daniel (PNG sin fondo)",
	"banner.name2": "Logo del encabezado",
	"banner.title": "Nombre grande",
	"banner.subtitle": "Párrafo debajo del nombre",
	// Sobre mí
	"about.title": "Imagen del título “Sobre mí”",
	"about.description": "Biografía (admite HTML)",
	// Gestión en video
	"testimonials.banner": "Foto de fondo",
	// Denuncias · tuits
	"reports.title": "Banner “DENUNCIAS”",
	// Denuncia aquí
	"reportForm.title": "Imagen del título",
	"reportForm.megaphone": "Megáfono",
	// La Milagrosa
	"contact.banner": "Foto de fondo",
	// Pie de página
	"footer.banner": "Foto de fondo",
	"footer.name2": "Logo del pie de página",
};

// ponytail: si aparece un campo nuevo se muestra su id tal cual, que es lo que
// se veía antes en todos. Se le pone nombre agregándolo al mapa de arriba.
export const fieldLabel = (section: string, id: string) =>
	FIELD_LABELS[`${section}.${id}`] || id;
